import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Clock } from 'lucide-react';

interface IdleTimeoutWarningProps {
  open: boolean;
  remainingSeconds: number;
  onStayActive: () => void;
}

const IdleTimeoutWarning: React.FC<IdleTimeoutWarningProps> = ({ open, remainingSeconds, onStayActive }) => {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="alert-glass-surface border-0">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-3">
            <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-full alert-glass-icon-halo">
              <Clock className="h-5 w-5" style={{ color: 'hsl(var(--alert-ruby))' }} />
            </span>
            Session Timeout Warning
          </AlertDialogTitle>
          <AlertDialogDescription>
            You've been inactive. For security, you'll be logged out in{' '}
            <span className="font-bold text-2xl alert-countdown-ruby tabular-nums">{remainingSeconds}</span> seconds.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onStayActive}>Stay Signed In</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default IdleTimeoutWarning;
